<div class="twe-tables-container">
    <div>
        <span class="section-title">Account transactions</span>
    </div>
    <sdps-tabs sdps-id="twe-table-tabs" class="twe-table-tabs">
        <sdps-tab-bar slot="bar" id="preset-filters">
            <sdps-tab-button class="preset-filter-tab" sdps-id="upcoming" selected>Upcoming</sdps-tab-button>
            <sdps-tab-button class="preset-filter-tab" sdps-id="standingAuth">Standing Authorizations</sdps-tab-button>
            <sdps-tab-button class="preset-filter-tab" sdps-id="recurring">Recurring</sdps-tab-button>
        </sdps-tab-bar>
    </sdps-tabs>
    <mm-table [showPaginationMessage]="false" [columnDefs]="columnDefs" [rowData]="rowData$ | async" [tableName]="'transactions'"
        [componentState$]="tweTableState$" (gridReadyEvent)="updateGridReady($event)" [showFilterCount]="false"
        [showTableOptions]="false" [showFloatingFilter]="false" [headerHeight]="35"></mm-table>
</div>